<style src="./Channels.css"></style>
<template>
    <div class="epg__channels">
        <div v-for="c in channels"
             :style="`height:${(c._isSelected) ? defaultTimeSlotHeight+expandedSlotHeight : defaultTimeSlotHeight}px`"
             :class="[
              'epg__channel', {
              'epg__channel--expanded': c._isSelected
              }]">
            <div class="epg__channel-image">
                <img :src="(images && images[c.id]) ? images[c.id] : emptyImageUrl" :alt="c.name"/>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'epg-channels',
    props: ['channels', 'emptyImageUrl', 'images', 'defaultTimeSlotHeight', 'defaultExpandedSlotHeight', 'expandedSlotHeight']
  }
</script>



// WEBPACK FOOTER //
// Channels.vue?4fe55975